import * as React from 'react';
import './CustomCheckbox.css';
const CustomCheckbox = props => {
    return (
      <label className={props.id + " checkbox-container"}>
        {props.dispvalue}
        <input style={{opacity: 0}} id={props.id} type={props.type} onChange={props.onChange} name={props.name} value={props.value} data-arg={props.dataarg}/>
        <span className="checkmark" />
      </label>
    );
}
export default CustomCheckbox;


// WEBPACK FOOTER //
// ./src/common/CustomCheckbox.tsx